// Polyfills for SSR compatibility - must run before any imports
export {};

interface NavigatorPolyfill {
  vendor: string;
  userAgent: string;
  platform: string;
}

interface LocationPolyfill {
  protocol: string;
  host: string;
  hostname: string;
  port: string;
  pathname: string;
  search: string;
  hash: string;
  href: string;
  origin: string;
}

if (typeof globalThis !== 'undefined') {
  // Polyfill navigator for Next.js dev tools
  if (typeof globalThis.navigator === 'undefined') {
    (globalThis as Record<string, unknown>).navigator = {
      vendor: 'Google Inc.',
      userAgent: 'Mozilla/5.0 (compatible; Next.js SSR)',
      platform: 'Server',
    } as NavigatorPolyfill;
  }

  // Polyfill window.location for SSR
  const win = globalThis.window as
    | (Window & { location?: LocationPolyfill })
    | undefined;
  if (typeof globalThis.window !== 'undefined' && win && !win.location) {
    const locationPolyfill: LocationPolyfill = {
      protocol: 'https:',
      host: 'localhost',
      hostname: 'localhost',
      port: '',
      pathname: '/',
      search: '',
      hash: '',
      href: 'https://localhost/',
      origin: 'https://localhost',
    };
    (win as { location?: LocationPolyfill }).location = locationPolyfill;
  }
}
